import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChip"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM8.5 19.5V18H7V19.5H4.5V4.5H7V6H8.5V4.5H11.25V6H12.75V4.5H15.5V6H17V4.5H19.5V19.5H17V18H15.5V19.5H12.75V18H11.25V19.5H8.5ZM7 8H17V16H7V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChip;
